export default __webpack_public_path__ + "static/media/passage01_blue.f2d9d2f3.svg";